import { useNavigate } from "react-router-dom";
import { NAVY, ORANGE, WHITE } from "./SharedLayout";
import "./ProductImage.css";

export function ProductTable({ products }) {
  return (
    <div style={{ overflowX: "auto", borderRadius: 16, boxShadow: "0 4px 20px rgba(0,0,0,0.06)", border: "1px solid #e5ecf9" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: NAVY }}>
            {["Product Name", "Strength", "Pack Size", "Indication"].map((h) => (
              <th key={h} style={{ padding: "16px 22px", color: "#fff", textAlign: "left", fontSize: 13, fontWeight: 700, letterSpacing: 0.5 }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {products.map((p, i) => (
            <tr key={i} style={{ background: i % 2 === 0 ? "#f8faff" : "#fff", borderBottom: "1px solid #e5ecf9" }}>
              <td style={{ padding: "16px 22px", fontWeight: 700, color: NAVY, fontSize: 14 }}>{p.title}</td>
              <td style={{ padding: "16px 22px", fontSize: 13, color: "#555" }}>{p.strength}</td>
              <td style={{ padding: "16px 22px", fontSize: 13, color: "#555" }}>{p.pack_size}</td>
              <td style={{ padding: "16px 22px", fontSize: 13, color: "#555" }}>{(p.indications || "").split(/\r?\n/)[0]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function ProductCTA() {
  const navigate = useNavigate();
  return (
    <div style={{ marginTop: 50, padding: "34px 40px", background: "#f5f7fb", borderRadius: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <div>
        <div style={{ fontWeight: 700, color: NAVY, fontSize: 18 }}>Need our complete product catalogue?</div>
        <div style={{ color: "#667", fontSize: 14, marginTop: 4 }}>Download our full portfolio with regulatory approvals and dossier availability.</div>
      </div>
      <div style={{ display: "flex", gap: 12 }}>
        <button style={{ background: NAVY, color: "#fff", border: "none", borderRadius: 8, padding: "12px 24px", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>Download Catalogue</button>
      </div>
    </div>
  );
}

export function ProductImage({ product }) {
  const productColor = "#1a3c6e";
  const productBg = "#f5f7fb";
  return (
    <div 
      className="product-image-container"
      style={{ 
        width: "100%", 
        height: 160, // Base height, CSS will make it larger
        background: product.image ? "#ffffff" : productBg, // White background for actual images
        borderRadius: 12, 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center", 
        position: "relative", 
        overflow: "hidden" 
      }}
    >
      {/* Only show decorative background elements for placeholder SVG */}
      {!product.image && (
        <>
          <div style={{ position: "absolute", top: -20, right: -20, width: 90, height: 90, borderRadius: "50%", background: productColor, opacity: 0.15 }} />
          <div style={{ position: "absolute", bottom: -10, left: -10, width: 60, height: 60, borderRadius: "50%", background: productColor, opacity: 0.1 }} />
        </>
      )}
      
      {/* Show actual product image if available, otherwise show SVG placeholder */}
      {product.image ? (
        <img 
          src={product.image} 
          alt={product.title}
          className="product-image-enhanced"
        />
      ) : (
        <>
          <svg width="48" height="72" viewBox="0 0 48 72" fill="none" style={{ position: "relative", zIndex: 1 }}>
            <rect x="14" y="4" width="20" height="60" rx="10" fill={productColor} opacity="0.25" />
            <rect x="14" y="28" width="20" height="36" rx="0" fill={productColor} opacity="0.5" />
            <rect x="14" y="28" width="20" height="36" rx="0" fill={productColor} opacity="0.3" />
            <rect x="16" y="2" width="16" height="8" rx="3" fill={productColor} opacity="0.6" />
            <rect x="14" y="4" width="20" height="60" rx="10" stroke={productColor} strokeWidth="2" fill="none" opacity="0.8" />
            <line x1="18" y1="34" x2="30" y2="34" stroke="white" strokeWidth="1.5" opacity="0.7" />
            <line x1="18" y1="40" x2="30" y2="40" stroke="white" strokeWidth="1" opacity="0.5" />
            <line x1="18" y1="46" x2="25" y2="46" stroke="white" strokeWidth="1" opacity="0.4" />
          </svg>
          <div style={{ position: "relative", zIndex: 1, marginTop: 6, fontSize: 11, fontWeight: 700, color: productColor, letterSpacing: 0.5, textAlign: "center", maxWidth: 120 }}>
            {product.strength}
          </div>
        </>
      )}
    </div>
  );
}

export function ProductModal({ product, onClose }) {
    if (!product) return null;
  const productColor = "#1a3c6e";
const productBg = "#f5f7fb";
const productBorder = "#dbe7f6";
  // const cat = categoryColors[product.category] || { bg: "#f5f7fb", text: NAVY, border: "#e5ecf9" };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(10, 20, 50, 0.65)", backdropFilter: "blur(6px)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 24, animation: "fadeIn 0.2s ease" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: WHITE, borderRadius: 24, maxWidth: 900, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 32px 80px rgba(0,0,0,0.3)", animation: "slideUp 0.25s ease", position: "relative" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 20, right: 20, width: 36, height: 36, borderRadius: "50%", background: "#f1f5f9", border: "none", fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10, color: "#334155", lineHeight: 1 }}>×</button>

        <div style={{ display: "flex", gap: 0 }}>
          <div style={{ width: 320, flexShrink: 0, background: productBg, borderRadius: "24px 0 0 24px", padding: "40px 32px", display: "flex", flexDirection: "column" }}>
            <div 
              className="product-image-modal-container"
              style={{ 
                width: "100%", 
                height: 220, // Base height, CSS will make it larger
                background: WHITE, 
                borderRadius: 16, 
                display: "flex", 
                flexDirection: "column", 
                alignItems: "center", 
                justifyContent: "center", 
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)", 
                marginBottom: 24, 
                overflow: "hidden", 
                position: "relative" 
              }}
            >
              {/* Only show decorative background elements for placeholder SVG */}
              {!product.image && (
                <div style={{ position: "absolute", top: -30, right: -30, width: 120, height: 120, borderRadius: "50%", background: productColor, opacity: 0.12 }} />
              )}
              
              {/* Show actual product image if available, otherwise show SVG placeholder */}
              {product.image ? (
                <img 
                  src={product.image} 
                  alt={product.title}
                  className="product-image-modal"
                />
              ) : (
                <>
                  <svg width="64" height="96" viewBox="0 0 48 72" fill="none">
                    <rect x="14" y="4" width="20" height="60" rx="10" fill={productColor} opacity="0.2" />
                    <rect x="14" y="28" width="20" height="36" rx="0" fill={productColor} opacity="0.45" />
                    <rect x="16" y="2" width="16" height="8" rx="3" fill={productColor} opacity="0.6" />
                    <rect x="14" y="4" width="20" height="60" rx="10" stroke={productColor} strokeWidth="2" fill="none" opacity="0.9" />
                    <line x1="18" y1="34" x2="30" y2="34" stroke="white" strokeWidth="1.5" opacity="0.8" />
                    <line x1="18" y1="40" x2="30" y2="40" stroke="white" strokeWidth="1.2" opacity="0.6" />
                    <line x1="18" y1="46" x2="26" y2="46" stroke="white" strokeWidth="1" opacity="0.5" />
                  </svg>
                  <div style={{ fontSize: 12, fontWeight: 700, color: productColor, marginTop: 8 }}>{product.strength}</div>
                </>
              )}
            </div>

            {/* <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: cat.bg, border: `1px solid ${cat.border}`, color: cat.text, fontSize: 12, fontWeight: 700, padding: "6px 14px", borderRadius: 20, marginBottom: 20, alignSelf: "flex-start" }}>
              <div style={{ width: 8, height: 8, borderRadius: "50%", background: cat.text }} />
              {product.category}
            </div> */}

            {[
  { label: "Strength", value: product.strength },
  { label: "Standard", value: product.standard },
  { label: "Type", value: product.type },
  { label: "Packing", value: product.packing },
  { label: "Pack Size", value: product.pack_size },
  { label: "Drug Type", value: product.drug_type }
].map((item, i) => (
              <div key={i} style={{ marginBottom: 14, paddingBottom: 14, borderBottom: i < 5 ? `1px solid ${productBorder}` : "none" }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1, marginBottom: 4 }}>{item.label}</div>
                <div style={{ fontSize: 13, color: NAVY, fontWeight: 600, lineHeight: 1.5 }}>{item.value}</div>
              </div>
            ))}
          </div>

          <div style={{ flex: 1, padding: "40px 40px 40px 36px" }}>
            <div style={{ marginBottom: 28, paddingRight: 40 }}>
              <h2
  style={{
    fontSize: 32,
    fontWeight: 400,
    color: NAVY,
    margin: "0 0 6px",
    letterSpacing: -0.5,
  }}
>
  {product.title}
</h2>

<div
  style={{
    width: 60,
    height: 3,
    background: ORANGE,
    borderRadius: 2,
    marginBottom: 10,
  }}
/>

<p
  style={{
    color: "#64748b",
    fontSize: 14,
    margin: 0,
    fontStyle: "italic",
  }}
>
  {product.generic_name}
</p>
            </div>

            <div style={{ marginBottom: 28 }}>
              <h3 style={{ fontSize: 14, fontWeight: 700, color: NAVY, textTransform: "uppercase", letterSpacing: 1, marginBottom: 10 }}>Description</h3>
              <p style={{ color: "#475569", fontSize: 14, lineHeight: 1.8, margin: 0 }}>{product.description}</p>
            </div>

            <div style={{ background: "#f8faff", border: "1px solid #e5ecf9", borderLeft: `4px solid ${ORANGE}`, borderRadius: 10, padding: "14px 18px", marginBottom: 28 }}>
              <span style={{ fontWeight: 700, color: NAVY, fontSize: 13 }}>Drug type: </span>
              <span style={{ color: "#475569", fontSize: 13 }}>{product.drug_type}</span>
            </div>

            <div>
              <h3 style={{ fontSize: 14, fontWeight: 700, color: NAVY, textTransform: "uppercase", letterSpacing: 1, marginBottom: 14 }}>Indications</h3>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                {(product.indications || "")
  .split(/\r?\n/)
  .filter(Boolean)
  .map((ind, i) => (
                  <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "10px 14px", background: "#f8faff", borderRadius: 8, border: "1px solid #e5ecf9" }}>
                    <div style={{ width: 6, height: 6, borderRadius: "50%", background: productColor, marginTop: 5, flexShrink: 0 }} />
                    <span style={{ color: "#334155", fontSize: 13, lineHeight: 1.5 }}>{ind}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes slideUp { from { transform: translateY(24px); opacity: 0 } to { transform: translateY(0); opacity: 1 } }
      `}</style>
    </div>
  );
}
